import {neverland as $, render, html, useState} from 'neverland';
import { confirmPassword } from '../lib/cognito.js';

const ConfirmForgotPasswordPage = $(function({auth, setAuth}) {
	
	async function tryReset() {
		document.getElementById('error-dontmatch').classList.add('hide');
		document.getElementById('error-generic').classList.add('hide');

		let username = auth.tempUser,
			code = document.getElementById('resetcode').value,
			pw1 = document.getElementById('pw1').value,
			pw2 = document.getElementById('pw2').value;


		if (pw1 !== pw2) {
			document.getElementById('error-dontmatch').classList.remove('hide');
			return;
		}

		try {
			await confirmPassword(username, code, pw1);
			window.history.replaceState({}, "New Password", "/");
			setAuth(prevAuth => ({
				...prevAuth,
				publicPage: 'ResetSuccess',
				tempUser: null,
			}));
		} catch(err) {
			console.warn(err);
			document.getElementById('error-generic').classList.remove('hide');
		}
	}

	function clickReset(event) {
		// Number 13 is the "Enter" key on the keyboard
		if (event.keyCode === 13) {
			event.preventDefault();
			document.getElementById("reset-button").click();
		}
	}

	return html`
		<div class='login-fields'>
			<h2>Reset your password</h2>
			<p>If an account exists for ${auth.tempUser}, a verification code has been sent.</p>
			
			<label>Reset Code</label>
			<input id="resetcode" maxlength="6" inputmode="numeric" placeholder="Enter 6-digit code" autofocus />

			<label>New Password</label>
			<input id="pw1" type="password" placeholder="Enter new password" autofocus />

			<label>Confirm New Password</label>
			<input id="pw2" type="password" placeholder="Confirm new password" onkeyup="${clickReset}" />

			<button id="reset-button" onclick="${tryReset}">Reset password</button>

			<div id="error-dontmatch" class="login-error hide">Passwords do not match</div>
			<div id="error-generic" class="login-error hide">Something went wrong</div>

		</div>
	`;

});

export default ConfirmForgotPasswordPage;